module.exports = __webpack_public_path__ + "img/roll-1536.06681343.png";